import { ReactComponent as Download } from "../../../../assets/icons/download.svg";
import { ReactComponent as Trash } from "../../../../assets/icons/trash.svg";
import { ReactComponent as Pencil } from "../../../../assets/icons/pencil.svg";
import { ReactComponent as UserPlus } from "../../../../assets/icons/user-plus.svg";
import { ReactComponent as DocumentDuplicate } from "../../../../assets/icons/document-duplicate.svg";
import { getLabel } from "../../utils/labels";
import { useApp } from "../../../../services/app-context";
import { twMerge } from "tailwind-merge";


export function ActionView({ onDelete, onExport, isAdmin, onEdit, onAddAssignees, onDuplicate, disableEditAndAssignees }: { onDelete: () => void, onExport: () => void, isAdmin: boolean, onEdit: () => void, onAddAssignees: () => void, onDuplicate: () => void, disableEditAndAssignees?: boolean }) {
    const { certificationAssets } = useApp();
    const labels = certificationAssets?.labels || {};
    const sessionSingular = getLabel("session.singular", labels);
    return (
        <div className="z-[100] w-[220px] bg-white shadow-[0_4px_14.1px_0_rgba(0,0,0,0.25)] border border-gray-100 rounded-[9px] mr-[60px]">
            <ul className="text-sm " aria-labelledby="dropdownMenuIconButton">
                <li onClick={onExport} className="flex items-center gap-3 hover:bg-gray-100 px-3 py-2 cursor-pointer">
                    <Download className="w-4 h-4 [&_path]:stroke-[#3F3F46]  " />
                    Export
                </li>
                {isAdmin &&
                    <>
                        <li
                            onClick={() => { if (!disableEditAndAssignees) onEdit(); }}
                            className={twMerge(
                                "flex items-center gap-3 px-3 py-2",
                                disableEditAndAssignees ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-100 cursor-pointer"
                            )}
                            aria-disabled={disableEditAndAssignees}
                        >
                            <Pencil className="w-4 h-4 [&_path]:stroke-[#3F3F46]" />
                            Edit
                        </li>
                        <li
                            onClick={() => { if (!disableEditAndAssignees) onAddAssignees(); }}
                            className={twMerge(
                                "flex items-center gap-3 px-3 py-2",
                                disableEditAndAssignees ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-100 cursor-pointer"
                            )}
                            aria-disabled={disableEditAndAssignees}
                        >
                            <UserPlus className="w-4 h-4 [&_path]:stroke-[#3F3F46]" />
                            Add/Remove Assignees
                        </li>
                        <li onClick={onDuplicate} className="flex items-center gap-3 hover:bg-gray-100 px-3 py-2 cursor-pointer">
                            <DocumentDuplicate className="w-4 h-4 [&_path]:stroke-[#3F3F46]" />
                            Duplicate {sessionSingular}
                        </li>
                        <>
                            <li className="px-3 py-1">
                                <div className="border-b border-[#E9E9E9] w-full" />
                            </li>
                            <li onClick={onDelete} className="flex items-center gap-3 hover:bg-gray-100 px-3 py-2 cursor-pointer text-red-500">
                                <Trash className="w-4 h-4 [&_path]:stroke-[#DC2626]" />
                                Delete {getLabel("session.singular", labels)}
                            </li>
                        </>
                    </>}
            </ul>
        </div>
    );
}
